// extracted by mini-css-extract-plugin
module.exports = {"CART_CARD":"CartCard_CART_CARD___W9ow","CART_CARD__delete_icon":"CartCard_CART_CARD__delete_icon__1jVKF"};